import { tokenStore } from './tokenStore'

/**
 * 세션 만료 처리의 **단일 경로**(설계 불변식 4).
 *
 * 어디서도 `window.location` 을 직접 만지지 않는다 — 라우터가 구독해서 이동을 수행하므로
 * 전체 페이지 리로드 없이 `/login` 으로 갈 수 있고, 테스트에서도 관측 가능하다.
 */
type Listener = () => void

const listeners = new Set<Listener>()

export function onSessionExpired(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/**
 * 토큰을 폐기하고 구독자에게 알린다.
 *
 * 🚨 **refresh 호출 자체가 401 일 때만** 호출한다. 갱신 후 재시도에서 나온 401 은
 * 유효 세션의 인가 실패이므로 세션을 지우면 안 된다(설계 불변식 5).
 */
export function triggerSessionExpired(): void {
  tokenStore.clear()
  listeners.forEach((listener) => {
    listener()
  })
}
